import DateTimes from 'components/Common/DateTimes';
import parse from 'date-fns/parse';
import isValid from 'date-fns/isValid';

function isDateAheadOfUtc(date) {
  const { utcDate } = DateTimes;
  return date > utcDate;
}

export function isValidSignedDate(input, dateFormat) {
  if (input.value) {
    const signedDate = parse(input.value, dateFormat, new Date());
    if (isValid(signedDate)) {
      return !isDateAheadOfUtc(signedDate);
    }
  }
  return false;
}

export function defaultSignedDate() {
  const currentDate = new Date(DateTimes.today.getFullYear(), DateTimes.today.getMonth(), DateTimes.today.getDate());
  return isDateAheadOfUtc(currentDate) ? DateTimes.utcDate : currentDate;
}
